import {
    type RegisterUserResponseType,
    type RegisterUserRequestType
} from "./type";
import {
    request
} from "../request";

const RegisterUser = async (params: RegisterUserRequestType): Promise<RegisterUserResponseType> => {
    return await request<RegisterUserResponseType>("/user/registerUser", {
        body: JSON.stringify(params),
        method: "POST"
    });
};

export default RegisterUser;
